module.exports = __webpack_public_path__ + "dc1340c8fc4067ba007f28b6c4fa707b.png";